module.exports = __webpack_public_path__ + "img/58.d2afe0a1.png";